import Image from 'next/image';
import styles from './Testimonial.module.css';

interface TestimonialProps {
  testimonial: {
    image: string;
    name: string;
    age: number;
    text: string;
    position?: string;
  };
}

const Testimonial = ({ testimonial }: TestimonialProps) => {
  const { image, name, age, text, position } = testimonial;

  return (
    <div className={styles.testimonial}>
      <Image
        width={100}
        height={100}
        src={image}
        alt={`${name}'s testimonial`}
      />
      <p className={styles.testimonialText}>{text}</p>
      <div>
        <p className={styles.personInfo}>{`${name}, ${age}`}</p>
        {position && <span className={styles.personPosition}>{position}</span>}
      </div>
    </div>
  );
};

export default Testimonial;
